// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { spacing } from '@iheartjane/reefer-emotion';
import { Form } from '@iheartjane/reefer-hook-form';

export const SwitchWithBorder = styled(Form.SwitchField)(({ theme }) => ({
  border: '1px solid',
  ...spacing({ px: 16, py: 12 }),
  borderRadius: theme.borderRadius.sm,
  borderColor: theme.colors.grays.light,
}));
